import { ConcreteEncodable } from "./ConcreteEncodable";

import { RateDataImplEncoder } from "../../encoder/RateDataImplEncoder";

import * as CubiqTS from "../../index";
import { RateData } from "../RateData";

export class RateDataImpl extends ConcreteEncodable implements RateData {
  public static enType: string = "com.bcdfx.model.event.lifecycle.RateDataImpl";

  /*FID=1*/
  public isMarketConvention: boolean;
  /*FID=2*/
  public book: CubiqTS.PositionBook | null = null;
  /*FID=3*/
  public spotMarketRate: CubiqTS.BigNumber | null = null;
  /*FID=4*/
  public forwardMarketPoints: CubiqTS.BigNumber | null = null;
  /*FID=5*/
  public marketAllIn: CubiqTS.BigNumber | null = null;
  /*FID=6*/
  public spotClientRate: CubiqTS.BigNumber | null = null;
  /*FID=7*/
  public forwardClientPoints: CubiqTS.BigNumber | null = null;
  /*FID=8*/
  public clientAllIn: CubiqTS.BigNumber | null = null;
  /*FID=9*/
  public componentRateData: Array<CubiqTS.RateData> | null = null;
  /*FID=10*/
  public baseCcyCd: string;
  /*FID=11*/
  public nonbaseCcyCd: string;
  /*FID=12*/
  public localBook: CubiqTS.PositionBook | null = null;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = RateDataImplEncoder.Instance;
    this.setEncodableType(RateDataImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "RateDataImpl[" +
      "isMarketConvention=" +
      this.isMarketConvention +
      "book=" +
      this.book +
      "spotMarketRate=" +
      this.spotMarketRate +
      "forwardMarketPoints=" +
      this.forwardMarketPoints +
      "marketAllIn=" +
      this.marketAllIn +
      "spotClientRate=" +
      this.spotClientRate +
      "forwardClientPoints=" +
      this.forwardClientPoints +
      "clientAllIn=" +
      this.clientAllIn +
      "componentRateData=" +
      this.componentRateData +
      "baseCcyCd=" +
      this.baseCcyCd +
      "nonbaseCcyCd=" +
      this.nonbaseCcyCd +
      "localBook=" +
      this.localBook +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
